var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "d-flex align-center py-3" },
        [
          _c(
            "v-icon",
            { staticClass: "mr-2", attrs: { large: "", color: _vm.iconColor } },
            [_vm._v(_vm._s(_vm.icon))]
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "text-h6 font-weight-medium" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _vm.displayTitlesView
            ? _c(
                "v-col",
                [
                  _c("title-list", {
                    attrs: {
                      displayNewBadge: false,
                      titles: _vm.items,
                      loading: _vm.loadingTitles,
                      displayBorder: "",
                      displayUserTypeLabel: "",
                      displayInCols: _vm.isMobilePort ? 12 : 6,
                    },
                  }),
                ],
                1
              )
            : _vm._l(_vm.items, function (item, index) {
                return _c(
                  "v-col",
                  { key: index, attrs: { cols: "12", sm: "6" } },
                  [
                    _c(
                      item.url ? "a" : "div",
                      { tag: "component", attrs: { href: item.url || null } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-4 hover-border rounded-lg",
                            attrs: { outlined: "" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "text-body-1 font-weight-medium" },
                              [_vm._v(_vm._s(item.title))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.hideDivider ? _c("v-divider", { staticClass: "my-3" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }